import { filtersHelper } from '@/utils';

function articleDescription(data) {
    const description = data.description ?? data.content ?? data.body ?? '';
    if (typeof description === 'string') return description;
    return description?.html ?? description?.content ?? description?.value ?? '';
}

export const articleModel = (data = {}) => ({
    uuid: data.uuid,
    title: data.title || data.name || '',
    authorName: data.author_name ?? data.author?.name ?? '',
    category: data.article_category || data.category || null,
    articleCategoryUUID: data.article_category_uuid || data.article_category?.uuid || data.category?.uuid || '',
    articleType: data.article_type || data.type || null,
    articleTypeUUID: data.article_type_uuid || data.article_type?.uuid || data.type?.uuid || '',
    visibleToCompany: data.visible_to_company || data.company || null,
    visibleToCompanyUUID: data.visible_to_company_uuid || data.visible_to_company?.uuid || data.company?.uuid || '',
    description: articleDescription(data),
    status: data.status == null ? null : Number(data.status),
    audienceType: data.audience_type == null ? 0 : Number(data.audience_type),
    isActive: data.is_active,
    coverImageUrl: data.cover_img_url || data.cover_img || data.cover_image_url || null,
    createdAt: filtersHelper.getDateFormat(data.created_at),
    createdBy: data.created_by,
    updatedAt: filtersHelper.getDateFormat(data.updated_at),
});
